function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import RadioButtonGroup, { propTypes as radioButtonGroupPropTypes } from '../RadioButtonGroup';
import FormControlGroup from '../FormControlGroup';
export var FormControlRadioButtonGroup = /*#__PURE__*/memo(function (props) {
  var options = props.options,
      label = props.label,
      value = props.value,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["options", "label", "value", "onChange"]);

  return /*#__PURE__*/React.createElement(FormControlGroup, {
    label: label,
    component: function component() {
      return /*#__PURE__*/React.createElement(RadioButtonGroup, Object.assign({
        color: "primary",
        options: options,
        value: value,
        onChange: onChange
      }, rest));
    }
  });
});
export var propTypes = _objectSpread({
  label: PropTypes.string
}, omit(radioButtonGroupPropTypes, 'onChange'));
FormControlRadioButtonGroup.propTypes = propTypes;
FormControlRadioButtonGroup.displayName = 'FormControlRadioButtonGroup';
export default FormControlRadioButtonGroup;